export default __webpack_public_path__ + "static/media/header-image.920cf3e1.png";